import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-date-range-input',
  templateUrl: './date-range-input.component.html',
  styleUrls: ['./date-range-input.component.css']
})
export class DateRangeInputComponent implements OnInit {
  comparator = '>=';
  @Output() valorDesdeChange = new EventEmitter();
  @Output() valorHastaChange = new EventEmitter();
  @Output() valorEntreChange = new EventEmitter();

  private _valorDesde: Date;
  @Input()
  get valorDesde(): Date {
    return this._valorDesde;
  }
  set valorDesde(desde: Date) {
    if (!desde) {
      this.rangeValues = [];
    }
    this._valorDesde = desde;
    this.valorDesdeChange.emit(this._valorDesde);
    if (this.mode === 'simpleRangeSearch') {
      this.valorHasta = this.valorDesde;
    }
  }

  private _valorHasta: Date;
  @Input()
  get valorHasta(): Date {
    return this._valorHasta;
  }
  set valorHasta(hasta: Date) {
    if (!hasta) {
      this.rangeValues = [];
    }
    this._valorHasta = hasta;
    this.valorHastaChange.emit(this._valorHasta);
  }
  @Input() nombreCampo: string;

  private _rangeValues: Date[];
  get rangeValues(): Date[] {
    return this._rangeValues;
  }
  set rangeValues(values: Date[]) {
    this._rangeValues = values;
    if (this.mode !== 'rangeSimple') {
      if (values && values.length >= 1) {
        this.valorDesde = values[0];
      }
      if (values && values.length >= 2) {
        this.valorHasta = values[1];
      }
    } else {
      this.valorEntreChange.emit({ desde: this._rangeValues[0], hasta: this._rangeValues[1] });
    }
  }

  @Input() mode: string;

  public bsConfig: BsDatepickerConfig;

  constructor(
    private utilsService: UtilitiesService,
    private localeService: BsLocaleService
  ) {}

  ngOnInit() {
    this.localeService.use(localStorage.getItem('idioma'));
    this.bsConfig = this.utilsService.getDatepickerConfig();
  }

  resetValues() {
    this.valorDesde = undefined;
    this.valorHasta = undefined;
    this.rangeValues = [];
  }
}
